// extracted by mini-css-extract-plugin
module.exports = {"Table":"Footers_Table__2nU2a"};